import { useContext, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../authContext/context';

function ProtectedRoutes() {
  const authCtx = useContext(AuthContext);
  const token = authCtx.token;

  let isLogin = !!token;


  return isLogin ? <Outlet /> : <Navigate replace to="/login" />;
}

export default ProtectedRoutes;
